import React, { useEffect, useState, useRef } from 'react'
import { withRouter } from 'react-router-dom'
import  { Captcha } from '../../components/captcha/captcha.component'
import loadNIASScript from '../../utils/load-nias-script'

import './verify.style.scss'

const VerifyPage = ({history, captchaEnter}) => {
  
  const childRef = useRef()
  const [verCode, setVercode] = useState(null)
  const [captcha, setCaptcha] = useState('')
  const [error, setError] = useState('')
  const captchaRef = useRef(null)

  useEffect(() => {
    loadNIASScript(null, null)
  },[])
 
  
  const handleInputChange = (e) => {
    setVercode(e.target.value)
  }

  const onFormSubmit = (e) => {
    e.preventDefault()
    if(captchaRef.current.value.toLowerCase() === captcha.toLowerCase()) {
      history.push(`/provjera/${verCode}`)
    } else {
      captchaRef.current.value = '';
      setError('Ne ispravan kod za provjeru')
      childRef.current.reset()
    }
  }
  
  return (
    <div className="verify">
      <div className="left-column">
        <form onSubmit={onFormSubmit}>
          <h3>Provjera vjerodostojnosti dokumenta</h3>
          <input type="text" className="text-input" onChange={handleInputChange} placeholder="Broj zapisa" />
          <input type="text" className="text-input" ref={captchaRef} placeholder="Kod za provjeru" />
          {error ? (<p className="captcha__error">{error}</p>) :null}
            <div className="captcha-wrap">
              <Captcha setCaptcha={setCaptcha} ref={childRef} width={130} height={35}/> 
            </div>
          
          <button className="verify-button" type="submit" >Provjeri</button>
        </form>
      </div>
      <div className="right-column">

      </div>
    </div>
  )
  
}



export default withRouter(VerifyPage)
